import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "antd/dist/antd.css";
import { Upload, Modal } from "antd";
import ObservadorFormulariFotoSelectorImatge from "./ObservadorFormulariFotoSelectorImatge";
import styles from "./ObservadorFormulariFoto.module.css";
import fotoNoTrobada from "../../images/fotoNoTrobada.jpg";
import senseImatge from "../../images/senseImatgeQuadrat.jpg";
import { observadorIntroduccioModificarCamp } from "../../actions";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class UploadObservador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: "",
      previewTitle: "",
      loading: false,
      fileList: [
        {
          uid: "-1",
          name: props.nomObservador,
          status: "done",
          url: props.fotoUrl ? props.fotoUrl : senseImatge
        }
      ]
    };
  }

  eliminarImatgeSeleccionada = () => {
    this.props.modificarCamp("foto", "");

    this.setState(() => {
      return { fileList: [] };
    });
  };

  handleCrearFoto = urlFoto => {
    const { onDisableComponent } = this.props;
    onDisableComponent(true);
    const promesaImagen = getBase64(urlFoto.fitxer);

    promesaImagen.then(img => {
      let newFileList = [...this.state.fileList];
      newFileList[0].url = img;
      this.setState(() => {
        return { fileList: newFileList };
      });

      this.props.modificarCamp("foto", urlFoto);

      onDisableComponent(false);
    });
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    });
  };

  handleChange = ({ file, fileList }) => {
    const props = this.props;
    if (file.status === "error") {
      fileList = [
        {
          uid: "-1",
          name: "Sense Foto",
          status: "error",
          url: fotoNoTrobada
        }
      ];
    }

    if (fileList.length === 0) {
      fileList = [
        {
          uid: "-1",
          name: "Sense Foto",
          status: "done",
          url: props.fotoUrl ? props.fotoUrl : senseImatge
        }
      ];
    }
    this.setState({ fileList });
  };

  render() {
    const { onDisableComponent, accioCanviFoto } = this.props;
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;

    return (
      <div className={styles.observadorFotoEdit}>
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp"
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          onRemove={this.eliminarImatgeSeleccionada}
          onDisableComponent={onDisableComponent}
          onLoad={() => {
            window.dispatchEvent(new Event("resize"));
          }}
        />

        <ObservadorFormulariFotoSelectorImatge
          className={styles.IntroduccioFoto}
          urlImatgeOriginal={this.props.urlFoto}
          crearFoto={this.handleCrearFoto}
          accioCanviFoto={accioCanviFoto}
        />

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="" style={{ maxWidth: "100%" }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

class ObservadorFormulariFoto extends Component {
  state = {
    show: false,
    updateFotoEnCurs: false,
    disableComponents: false
  };

  showModal = () => {
    this.setState({
      show: true
    });
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  render() {
    const {
      onDisableComponent,
      observadorIntroduccioModificarCamp,
      fotoUrl,
      nomObservador
    } = this.props;
    return (
      <div>
        <UploadObservador
          onDisableComponent={onDisableComponent}
          modificarCamp={observadorIntroduccioModificarCamp}
          fotoUrl={fotoUrl}
          nomObservador={nomObservador}
        />
      </div>
    );
  }
}

ObservadorFormulariFoto.propTypes = {
  onDisableComponent: PropTypes.func.isRequired,
  observadorIntroduccioModificarCamp: PropTypes.func
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, { observadorIntroduccioModificarCamp })(
  ObservadorFormulariFoto
);
